"use client";

import { MessageSquare, Plus } from "lucide-react";

import {
	Command,
	CommandEmpty,
	CommandGroup,
	CommandInput,
	CommandItem,
	CommandList,
} from "@/components/ui/command";
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";

import type { Chat } from "@/hooks/useChats";

interface CommandPaletteProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	chats: Chat[];
	onSelectChat: (chatId: string) => void;
	onNewChat: () => void;
}

export function CommandPalette({
	open,
	onOpenChange,
	chats,
	onSelectChat,
	onNewChat,
}: CommandPaletteProps) {
	const sortedChats = [...chats].sort(
		(a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
	);

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="overflow-hidden p-0 sm:max-w-lg">
				<DialogHeader className="sr-only">
					<DialogTitle>Search conversations</DialogTitle>
				</DialogHeader>
				<Command className="[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-input-wrapper]]:h-11">
					<CommandInput placeholder="Search conversations…" />
					<CommandList className="max-h-[60vh]">
						<CommandEmpty>No conversations found.</CommandEmpty>
						<CommandGroup heading="Actions">
							<CommandItem
								value="new chat start conversation"
								onSelect={() => {
									onOpenChange(false);
									onNewChat();
								}}
							>
								<Plus className="h-4 w-4" />
								New chat
							</CommandItem>
						</CommandGroup>
						{sortedChats.length > 0 && (
							<CommandGroup heading="Conversations">
								{sortedChats.map((chat) => (
									<CommandItem
										key={chat.id}
										value={`${chat.title} ${chat.id}`}
										onSelect={() => {
											onOpenChange(false);
											onSelectChat(chat.id);
										}}
									>
										<MessageSquare className="h-4 w-4 shrink-0 text-muted-foreground" />
										<span className="truncate">{chat.title}</span>
									</CommandItem>
								))}
							</CommandGroup>
						)}
					</CommandList>
				</Command>
			</DialogContent>
		</Dialog>
	);
}
